import { useEffect, useState } from 'react';
import { Package, Calendar } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { api, money } from '@/lib/api';

const statusColor = {
  pending: 'text-muted-foreground', confirmed: 'text-gold', shipped: 'text-blue-400', delivered: 'text-green-400',
};

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => { api.get('/orders').then(({ data }) => setOrders(data)); }, []);

  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-5xl mx-auto py-16">
      <p className="eyebrow mb-3">Your Maison</p>
      <h1 className="font-serif text-4xl lg:text-5xl mb-2">{user?.name}</h1>
      <p className="text-muted-foreground text-sm mb-12">{user?.email}</p>

      <h2 className="font-serif text-2xl mb-6 flex items-center gap-2"><Package size={20} className="text-gold" /> Order History</h2>
      {orders.length === 0 ? (
        <p className="text-muted-foreground text-sm">You have no orders yet.</p>
      ) : (
        <div className="space-y-5">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="border border-border bg-surface p-6">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="font-mono text-xs text-muted-foreground">#{o.id.slice(4, 14).toUpperCase()}</p>
                  <p className="text-xs text-muted-foreground mt-1">{new Date(o.created_at).toLocaleDateString()}</p>
                </div>
                <div className="text-right">
                  <p className="font-mono text-gold">{money(o.total, o.currency)}</p>
                  <p className={`text-xs font-mono uppercase mt-1 ${statusColor[o.status] || 'text-muted-foreground'}`}>{o.status}</p>
                </div>
              </div>
              <div className="space-y-1 mb-4">
                {o.items.map((it, i) => (
                  <p key={i} className="text-sm text-muted-foreground">{it.quantity} × {it.name} {it.is_presale && <span className="text-[#F3D082]">(Presale)</span>}</p>
                ))}
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground border-t border-border pt-3">
                <Calendar size={13} className="text-gold" /> Delivery {o.delivery_date} · {o.delivery_slot}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
